export default "__VITE_ASSET__35588a98__"